import { postgrestError } from "./helpers/postgrestErrorHelper";
import { getManagedContent } from "./generated/calls/managed-content/managed-content";
import type { ManagedContent as ManagedContentDTO } from "./generated/models";
import type { APIResult } from "./types";

export type { ManagedContentDTO };

export async function fetchManagedContent(): Promise<
  APIResult<ManagedContentDTO[]>
> {
  try {
    const managedContentRes = await getManagedContent();
    switch (managedContentRes.status) {
      // A read narrowed by `limit`, `offset` or a `Range` header answers 206
      // and carries the same rows as a 200.
      case 200:
      case 206:
        return {
          success: true,
          data: managedContentRes.data,
        };
      default:
        throw postgrestError("Fetch failed", managedContentRes);
    }
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
